import {PaymentMethod} from '@wix/wixstores-graphql-schema-node';
import {calcVisibleViolations} from './violations.utils';
import {CartModel} from '../models/Cart.model';
import {EstimatedTotalsModel} from '../models/EstimatedTotals.model';
import {ViolationModel} from '../models/Violation.model';
import {getUniques} from './getUniques';

const BI_AMOUNT_MULTIPLIER = 100000;
export const toBiAmount = (amount: number) => Math.round(amount * BI_AMOUNT_MULTIPLIER);

export const getCatalogAppIds = (cartModel: CartModel): string => {
  return getMappedUniqueList(
    cartModel?.lineItems,
    ({catalogReference}) => catalogReference?.appId || 'no-catalog-app-id'
  );
};

export const getItemTypes = (cartModel: CartModel): string => {
  return getMappedUniqueList(cartModel.lineItems, ({itemType}) => itemType);
};

function getMappedUniqueList<T>(arr: T[] | undefined, mapper: (t: T) => string | undefined | null): string {
  return getUniques((arr ?? /* istanbul ignore next */ []).map(mapper).filter(isDefined)).toString();
}

const isDefined = <T>(obj: T): boolean => {
  return !!obj;
};

export const getAdditionalFeesPrice = (estimatedTotals: EstimatedTotalsModel): number => {
  return toBiAmount(estimatedTotals?.priceSummary?.additionalFees?.convertedAmount ?? 0);
};

export const getValidations = (violations: ViolationModel[]): string | undefined => {
  if (violations?.length > 0) {
    const top3violations = calcVisibleViolations(violations);
    const biViolations = top3violations.map((violation) => {
      return {
        type: violation.severity,
        is_line_item: Boolean(violation.target?.lineItemTarget?.id),
        message: violation.description,
        name: violation.target?.otherTarget?.name || violation.target?.lineItemTarget?.name,
      };
    });

    return JSON.stringify(biViolations);
  }

  return undefined;
};

export const stringifyPaymentMethods = (paymentMethods: PaymentMethod[]): string => {
  return paymentMethods.map((m) => m.name).join(',');
};

export const getNumberOfAdditionalFees = (estimatedTotals: EstimatedTotalsModel): number => {
  return estimatedTotals?.additionalFees?.length || 0;
};

export const getItemsCount = (cartModel: CartModel): number => {
  return cartModel?.lineItems.reduce((count, lineItem) => count + lineItem.quantity, 0) || 0;
};
